<ng-container *ngIf="!cargando; else loading">
  <div div class="ticket-info filtros-tipos" [formGroup]="filtrosForm">
    <select
      formControlName="grupoRecinto"
      (change)="cambiodeFiltro($event.target.value)"
    >
      <option value="" disabled selected hidden>{{ 'FILTRAR_POR_TEATRO' | translate }}</option>
      <option
        *ngFor="let grupoRecinto of grupoRecintos"
        [value]="grupoRecinto"
        >{{ grupoRecinto }}</option
      >
    </select>
    <div class="inputControl">
      <input
        class="cliente"
        formControlName="busqueda"
        type="text"
        placeholder="{{ 'BUSCAR' | translate }}"
        (input)="cambiodeFiltro($event.target.value)"
      />
    </div>
  </div>
  <div class="Rtable">
    <div class="Rtable-row Rtable-row--head">
      <div class="Rtable-cell status-cell column-heading">STATUS</div>
      <div class="Rtable-cell espectaculo-cell column-heading">{{ 'ESPECTACULO' | translate }}</div>
      <div class="Rtable-cell recinto-cell column-heading">{{ 'RECINTO' | translate }}</div>
      <div class="Rtable-cell fechas-cell column-heading">{{ 'FECHAS' | translate }}</div>
      <div class="Rtable-cell precios-cell column-heading">{{ 'PRECIOS' | translate }}</div>
    </div>
    <div class="listado" id="entradas" *ngFor="let e of pagedItems">
      <div
        class="Rtable-row"
        (click)="seleccionarEspectaculo(e)"
        [ngClass]="{ selected: espectaculoSeleccionado === e }"
      >
        <div class="Rtable-cell status-cell" [ngClass]="checkStatus(e.iEstado)">
          <div class="Rtable-cell--content status-content">
            {{ e.iEstado | estado }}
          </div>
        </div>
        <div class="Rtable-cell espectaculo-cell">
          <div class="Rtable-cell--content espectaculo-content">
            {{ e.chNombreEspectaculo }}
          </div>
        </div>
        <div class="Rtable-cell recinto-cell">
          <div class="Rtable-cell--content recinto-content">
            {{ e.chNombreGrupoRecintos }}
          </div>
        </div>
        <div class="Rtable-cell fechas-cell">
          <div class="Rtable-cell--content fechas-content">
            {{ e.dtFecha | date: 'yyyy/MM/dd':'es-ES' }} -
            {{ e.dtFechaMax | date: 'yyyy/MM/dd':'es-ES' }}
          </div>
        </div>
        <div class="Rtable-cell precios-cell">
          <div class="Rtable-cell--content precios-content">
            {{ e.fPrecioMin | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }} -
            {{ e.fPrecioMax | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
    <li>
      <a (click)="setPage(pager.currentPage - 1)" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
      </a>
    </li>
    <li *ngFor="let page of pager.pages">
      <a
        (click)="setPage(page)"
        [ngClass]="{ active: pager.currentPage === page }"
        >{{ page }}</a
      >
    </li>
    <li>
      <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
      </a>
    </li>
  </ul>
  <!--   <ul class="pagination" *ngIf="numEspectaculos">
    <li>
      <a (click)="anterior()" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
      </a>
    </li>
    <li *ngFor="let item of pager.pages">
      <a (click)="irPagina(item)" [ngClass]="{ active: item === page }">{{
        item
      }}</a>
    </li>
    <li>
      <a (click)="siguiente()" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
      </a>
    </li>
  </ul> -->
</ng-container>
<div>
  <ng-template #loading class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-template>
</div>
